<div *ngIf="!isWizard">
  <div class="sub-header">{{'onboarding.select_location ' | translate}}</div>

  <div class="row margin-top-8" *ngIf="!gettingData">
    <div class="col-md-4 label">
      Select Subsidiary:
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-home"></i></span>
        <p-dropdown [options]="subsidiaries" [(ngModel)]="config.SubsidiaryID"
                    placeholder="Subsidiary">
        </p-dropdown>
      </div>
    </div>
  </div>
  <div class="row margin-top-8" *ngIf="!gettingData">
    <div class="col-md-4 label">
      {{'onboarding.select_location' | translate}}:
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-user"></i></span>
        <p-dropdown [options]="locations" [(ngModel)]="config.LocationID"
                    placeholder="{{'onboarding.select_location' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>
  <div class="row margin-top-32">
    <div class="col-md-8"></div>
    <div class="col-md-4">
      <button type="submit" class="iso-round-button" style="float: right;"
              (click)="updateConfig()"
              [disabled]="busy || (!config.LocationID || !config.SubsidiaryID || config.LocationID == 0 || config.SubsidiaryID == 0)">{{ busy ? ('onboarding.button.please_wait' | translate) : (config.LocationID) ? ('onboarding.button.update_config' | translate) : ('onboarding.button.set_config' | translate)}}</button>
    </div>
  </div>


  <div *ngIf="technicians && technicians.length > 0 && isWorkshop">
    <div class="sub-header margin-top-16">
      {{ "bikeshop.shop_profile.pos-integration.technichan_linking" | translate }}
    </div>
    <div><small>{{ "bikeshop.shop_profile.pos-integration.technichan_linking_info" | translate }}</small></div>
    <div *ngFor="let technician of technicians" class="row margin-top-8">
      <div class="col-md-4 label">
        {{technician.Firstname}} {{technician.Surname}}
      </div>
      <div class="col-md-8">
        <p-dropdown [options]="users" [(ngModel)]="technician.POSEmployeeID" [showClear]="true"
                    placeholder="{{ 'bikeshop.shop_profile.pos-integration.link_technician_to_pos_employee' | translate }}">
        </p-dropdown>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-8 label"></div>
      <div class="col-md-4">
        <button type="submit" class="iso-round-button" style="float: right;"
                (click)="updateTechnicians()"
                [disabled]="busyTechnicians">{{ busy ? ('onboarding.button.please_wait' | translate) : ('bikeshop.shop_profile.pos-integration.updated_linked_technicians' | translate) }}</button>
      </div>
    </div>
  </div>

</div>
